import classNames from 'classnames';
import styles from './Icon.module.scss';

export interface IconProps {
	title?: string;
	className?: string;
	children: React.ReactNode;
	ariaHidden?: boolean;
	type?: 'circle' | 'rectangle';
	style?: 'none' | 'primary' | 'secondary';
	size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

export const UI_Icon = ({ title, style = 'primary', size = 'md', type, className, ariaHidden = true, children }: IconProps) => (
	<span
		aria-label={title}
		className={classNames(styles.Icon, styles[`Icon___${style}`], styles[`Icon___${size}`], styles[`Icon___${type}`], className)}
		aria-hidden={ariaHidden}
	>
		{children}
	</span>
);
